module.exports = __webpack_public_path__ + "static/media/upload-date-health.7863fa59.svg";